import en from './en'
import es from './es'
export const languageLabels = [
{
  code: en.code,
  label: en.label,
  shortName: 'EN',
},
{
  code: es.code,
  label: es.label,
  shortName: 'ES',
},
]
export default {
  default: en.code,
  enUS: en.code,
  esUS: es.code,
  [en.code]: en,
  [es.code]: es,
}